import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import StepProgressBar, { Step } from '../StepProgressBar';
import useAdditionalWorkflowLaunchNavigator from './additionalWorkflowLaunchNavigator';

export enum AdditionalWorkflowStepId {
  KEY_DATES = 1,
  ALL_TASKS = 2,
  CONFLICTS = 3,
  PARTIES = 4,
}

export interface AdditionalWorkflowStepsProps {
  currentStep: AdditionalWorkflowStepId;
  disabled?: boolean;
  hasConflicts?: boolean;
}

export default function AdditionalWorkflowSteps(props: AdditionalWorkflowStepsProps) {
  const navigator = useAdditionalWorkflowLaunchNavigator();
  const featureToggleService = useFeatureToggleService();
  const isNewFlowEnabled = featureToggleService.isApplyAdditionalWorkflowEnabled();

  const steps: Step[] = [
    {
      id: AdditionalWorkflowStepId.KEY_DATES,
      name: 'Edit Key Dates',
      onClick: () => navigator.openKeyDateTasksPage(),
      disabled: props.disabled,
    },
    {
      id: AdditionalWorkflowStepId.ALL_TASKS,
      name: 'Edit All Tasks',
      onClick: () => navigator.openAllTasksPage(),
      disabled: props.disabled,
    },
  ];

  if (isNewFlowEnabled && props.hasConflicts) {
    steps.push({
      id: AdditionalWorkflowStepId.CONFLICTS,
      name: 'Resolve Conflicts',
      onClick: () => navigator.openConflictsPage(),
      disabled: props.disabled,
    });
  }

  steps.push({
    id: AdditionalWorkflowStepId.PARTIES,
    name: 'Add Transaction Parties',
    onClick: () => navigator.openPartiesPage(),
    disabled: props.disabled,
  });

  return (
    <StepProgressBar steps={steps} currentStep={props.currentStep} withTitles />
  );
}
